import React, { Fragment } from "react";
import ManageUserComponent from "../component/app/manageUser/ManageUser.component";

const ManageUsersPage = () => {
  return (
    <Fragment>
      <ManageUserComponent />
    </Fragment>
  );
};

export default ManageUsersPage;
